import { Controller } from "@hotwired/stimulus"

// Flips [data-template-option] blocks, accent and font live; the server render stays the source of truth.
export default class extends Controller {
  static targets = ["paper"]

  sync() {
    const article = this.paperTarget.querySelector("article")
    this.element.querySelectorAll("input[type=checkbox][data-option]").forEach((box) => {
      this.paperTarget.querySelectorAll(`[data-template-option="${box.dataset.option}"]`).forEach((el) => { el.hidden = !box.checked })
    })
    const accent = this.element.querySelector("input[data-accent]:checked")
    if (accent) article.style.setProperty("--accent", accent.value)
    const font = this.element.querySelector("select[data-font]")
    if (font) article.style.fontFamily = `'${font.value}', sans-serif`
  }
}
